export const POC_PROFILES: string[] = ['demonstration', 'poc-eemovel'];
